import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslationService } from '../services/translation/translation.service';

/**
 * Strategy that updates the browser tab title dynamically based on the current route data.
 * Resolves translation keys and appends the "Eaze Customs - " prefix.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  /** Angular Title service to update the document title. */
  private readonly title = inject(Title);
  /** Service to translate page title keys dynamically. */
  private readonly translationService = inject(TranslationService);

  /**
   * Updates the document title when routing completes.
   * 
   * @param routerState - Current router state snapshot
   */
  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      const translatedTitle = this.translationService.translate(title);
      this.title.setTitle(`Eaze Customs - ${translatedTitle}`);
    } else {
      this.title.setTitle('Eaze Customs');
    }
  }
}
